import type { ThemedTextInput } from '@trmediaab/zebra';

// We need to use attribute selectors in order to win in
// specificity over css on the Joker site.
const inputSelectors = [
  "&[type='text']",
  "&[type='number']",
  "&[type='email']",
  "&[type='password']",
  "&[type='url']",
  "&[type='tel']",
];

const common = {
  borderColor: 'border.primary',
  borderWidth: 1,
  borderStyle: 'solid',
  borderRadius: 1,
  boxShadow: 'textInput',
  width: '100%',
  '&:focus-visible': {
    outline: 'none',
    boxShadow: 'textInputFocus',
  },
};

const textInput: ThemedTextInput = {
  line: {
    variants: {
      default: {
        px: 3,
        [inputSelectors.join(', ')]: {
          ...common,
          textIndent: 0,
          height: 'buttonHeights.xlarge',
          lineHeight: 'buttonHeights.xlarge',
        },
      },
    },
  },
  area: {
    variants: {
      default: {
        ...common,
        height: '150px',
        p: 3,
      },
    },
  },
};

export default textInput;
